'use client';

// Page de démonstration du socle (Lot 0) : tokens, thème commutable, i18n.
// Sera remplacée par la vraie landing / bibliothèque dans les tranches suivantes.

import { useT } from '@/hooks/useT';
import { useTheme, type ThemeMode } from '@/lib/theme/ThemeProvider';
import { fontStyle } from '@/theme/typography';

const SWATCHES = ['background', 'surface', 'action', 'brand', 'danger', 'warning', 'success', 'info'] as const;
const MODES: ThemeMode[] = ['auto', 'light', 'dark'];

export default function HomePage() {
  const { t, i18n } = useT();
  const { mode, setMode } = useTheme();

  return (
    <main className="mx-auto flex w-full max-w-3xl flex-col gap-8 px-6 py-16">
      <header className="flex flex-col gap-2">
        <h1 style={fontStyle('displayXl')} className="font-display text-text-primary">
          {t('app.name')}
        </h1>
        <p style={fontStyle('bodyLg')} className="font-body text-text-secondary">
          {t('app.tagline')}
        </p>
      </header>

      <section className="flex flex-col gap-3">
        <span style={fontStyle('caption')} className="uppercase tracking-wide text-text-tertiary">
          {t('theme.label')}
        </span>
        <div className="flex gap-2">
          {MODES.map((m) => (
            <button
              key={m}
              type="button"
              onClick={() => setMode(m)}
              style={fontStyle('button')}
              className={[
                'rounded-md px-4 py-2 transition-colors',
                mode === m ? 'bg-action text-action-on' : 'bg-action-muted text-action hover:bg-border',
              ].join(' ')}
            >
              {t(`theme.${m}`)}
            </button>
          ))}
        </div>
      </section>

      <section className="flex flex-col gap-3">
        <span style={fontStyle('caption')} className="uppercase tracking-wide text-text-tertiary">
          {t('language.label')}
        </span>
        <div className="flex gap-2">
          {(['fr', 'en'] as const).map((lng) => (
            <button
              key={lng}
              type="button"
              onClick={() => void i18n.changeLanguage(lng)}
              style={fontStyle('button')}
              className={[
                'rounded-md px-4 py-2 transition-colors',
                i18n.language === lng ? 'bg-brand text-brand-on' : 'bg-action-muted text-action hover:bg-border',
              ].join(' ')}
            >
              {t(`language.${lng}`)}
            </button>
          ))}
        </div>
      </section>

      <section className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        {SWATCHES.map((token) => (
          <div key={token} className="overflow-hidden rounded-lg border border-border">
            <div className="h-16" style={{ background: `var(--rmbr-${token})` }} />
            <div className="bg-surface px-3 py-2">
              <span style={fontStyle('bodySm')} className="text-text-secondary">
                {token}
              </span>
            </div>
          </div>
        ))}
      </section>
    </main>
  );
}
